import { render, staticRenderFns } from "./loan-active-by-co.vue?vue&type=template&id=17352939&"
import script from "./loan-active-by-co.vue?vue&type=script&lang=js&"
export * from "./loan-active-by-co.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports